
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class VerifyPassword extends Vue {
  get isAuth(): boolean {
    return this.$store.getters.getIsAuth;
  }

  get loggedInError(): boolean {
    return !!this.$route.query.loggedIn;
  }

  get linkError(): boolean {
    return !!this.$route.query.linkError;
  }

  get message(): string {
    if (this.linkError) {
      return this.$t('verifyPassword.messages.linkError') as string;
    }

    if (this.loggedInError || this.isAuth) {
      return this.$t('verifyUser.messages.alreadyLoggedIn') as string;
    }

    return '';
  }

  get actionButtonTo(): { [key: string]: string } | string {
    return this.isAuth ? { name: 'logout' } : '/';
  }

  get actionButtonText(): string {
    return this.$t(`buttons.${this.isAuth ? 'logout' : 'homepage'}`) as string;
  }
}
